import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'
import { submitAffiliateRequest } from '@/api/support.api'
import { LANDING_PAGE_URL } from '@/config/constants'

export function NotAffiliate() {
  const { memberInfo, logout } = useAuth()
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleRequest = async () => {
    if (loading || submitted) return

    setLoading(true)
    setError(null)

    try {
      const name = memberInfo
        ? `${memberInfo.firstName} ${memberInfo.lastName} (${memberInfo.phoneNumber})`
        : 'Unknown member'
      await submitAffiliateRequest(`Affiliate partnership request from ${name}`)
      setSubmitted(true)
    } catch {
      setError('Failed to submit request. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold">Become an Affiliate Partner</h1>
          <p className="mt-2 text-muted-foreground">
            Your account is not registered as an affiliate partner. Submit a
            request to join the Mezza affiliate program.
          </p>
        </div>

        <div className="space-y-4">
          {submitted ? (
            <div className="rounded-xl border border-green-200 bg-green-50 p-4 text-center text-sm text-green-800 dark:border-green-800 dark:bg-green-950 dark:text-green-200">
              Your request has been submitted. We'll review it shortly.
            </div>
          ) : (
            <>
              <Button
                className="h-12 w-full rounded-xl text-base font-bold"
                onClick={handleRequest}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Request Affiliate Access'}
              </Button>

              {error && (
                <p className="text-center text-sm text-destructive">{error}</p>
              )}
            </>
          )}

          <Button
            variant="ghost"
            className="h-12 w-full rounded-xl text-base"
            onClick={logout}
          >
            Log out
          </Button>
        </div>

        <p className="text-center text-sm text-muted-foreground">
          Don't have a Mezza account?{' '}
          <a
            href={LANDING_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-primary hover:underline"
          >
            Sign up here
          </a>
        </p>
      </div>
    </div>
  )
}
